import { render } from "./ToastWelcom.vue?vue&type=template&id=95420490"
import script from "./ToastWelcom.vue?vue&type=script&lang=js"
export * from "./ToastWelcom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__